import BaseTheme from './theme-base';
import { createGlobalStyle } from 'styled-components';

const SpringboardTheme = {
    ...BaseTheme,
    // springboard theme settings
    headerHeight: '40px',
    footerHeightMD: '0px',
    footerHeightLG: '0px',
    modalBackgroundTop: '40px',
    stickyTop: '40px',
    navPaddingTopBottom: '0.15rem',
};

export const SpringboardGlobalStyle = createGlobalStyle`
    @media screen and (min-width: 768px) {
        .app-trail th.sticky-top {
            top: calc(${SpringboardTheme.headerHeight} + 36px) !important;
        }
        .app-trail .sidebar-filters {
            top: calc(${SpringboardTheme.headerHeight} + 39px) !important;
        }
    }
`;

export default SpringboardTheme;
